<template lang="pug">
.page-loader(v-if="loading")
  div
    img(v-if="showLogo").load-icon.animated.bounce(
      alt="Cybersmart Loading",
      src="/img/CYBERSMART-icon.svg"
    )
    p(v-html="message ? meassage : 'Loading...'")
    button.button.is-primary(
      v-if="retry",
      @click.prevent="$emit('load-retry')"
    ) RETRY
</template>

<script>
import brand from "@/brand";

export default {
  name: "Loader",
  props: {
    loading: {
      default: false,
    },
    message: {
      default: null,
    },
    retry: {
      default: false,
    },
  },
  computed: {
    showLogo() {
      const show = {
        "cybersmart": true,
        "ftta"      : false,
        "gigalight" : false,
      };

      return show[brand.getBrand()];
    }
  }
};
</script>

<style lang="sass" scoped>
.page-loader
    position: fixed
    background: rgba(255, 255, 255, 1)
    z-index: 999
    top: 0
    right: 0
    bottom: 0
    left: 0
    display: flex

    div
        margin: auto
        width: 100%
        text-align: center

    .load-icon
        width: 100px

.animated
    -webkit-animation-duration: .5s
    animation-duration: .5s
    -webkit-animation-fill-mode: both
    animation-fill-mode: both
    -webkit-animation-timing-function: linear
    animation-timing-function: linear
    animation-iteration-count: infinite
    -webkit-animation-iteration-count: infinite

@-webkit-keyframes bounce
  0%, 100%
    -webkit-transform: translateY(0)

  50%
    -webkit-transform: translateY(-10px)

@keyframes bounce
    0%, 100%
        transform: translateY(0)

    50%
        transform: translateY(-10px)

.bounce
    -webkit-animation-name: bounce
    animation-name: bounce
</style>